export type TeamsPersonStatus =
  | 'near_limit'
  | 'at_daily_limit'
  | 'shared_credits_only'
  | 'plan_underused'
  | 'seat_unused'
  | null;

export type TeamsUsageFilter = 'all' | 'at_or_near_limit' | 'not_using';

export type TeamsPerson = {
  id: string;
  initials: string;
  name: string;
  email: string;
  isYou?: boolean;
  plan: string | null;
  creditsUsed: number | null;
  creditsLimit: number | null;
  sharedCreditsLabel: string | null;
  tokensThisWeek: number;
  percentOfAll: number;
  /** False once an admin switched the person off from the shared credits. */
  creditAccess?: boolean;
  /** dd.MM.yyyy, or null when they never logged in. */
  lastLogin?: string | null;
  status: TeamsPersonStatus;
};

export const TEAMS_WORKSPACE_LABEL = 'SELISE Management';
export const TEAMS_PEOPLE_COUNT = 21;
export const TEAMS_REQUESTS_COUNT = 3;

/** Figma Teams Usage table (10827:11147) plus filler rows for the Not using filter. */
export const TEAMS_PEOPLE: TeamsPerson[] = [
  {
    id: '1',
    initials: 'AK',
    name: 'Andreas Kimpouropoulos',
    email: 'andreas.kimpouropoulos@selisegroup.com',
    plan: 'Business Standard',
    creditsUsed: 3720,
    creditsLimit: 4000,
    sharedCreditsLabel: null,
    tokensThisWeek: 62480000,
    percentOfAll: 31.5,
    status: 'near_limit',
  },
  {
    id: '2',
    initials: 'ER',
    name: 'Elena Rossi',
    email: 'elena.rossi@selisegroup.com',
    plan: 'Business Standard',
    creditsUsed: 2640,
    creditsLimit: 4000,
    sharedCreditsLabel: null,
    tokensThisWeek: 44120000,
    percentOfAll: 22.3,
    status: null,
  },
  {
    id: '3',
    initials: 'AE',
    name: 'Alvi Ehsan',
    email: 'alvi.ehsan@selisegroup.com',
    plan: 'Business Standard',
    creditsUsed: 1480,
    creditsLimit: 4000,
    sharedCreditsLabel: null,
    tokensThisWeek: 31760000,
    percentOfAll: 16.0,
    status: null,
  },
  {
    id: '4',
    initials: 'DC',
    name: 'Deepsika Chhetri',
    email: 'deepsika.chhetri@selisegroup.com',
    plan: 'Starter',
    creditsUsed: 1180,
    creditsLimit: 1500,
    sharedCreditsLabel: null,
    tokensThisWeek: 21340000,
    percentOfAll: 10.8,
    status: 'at_daily_limit',
  },
  {
    id: '5',
    initials: 'JW',
    name: 'Jonas Weber',
    email: 'jonas.weber@selisegroup.com',
    plan: 'Starter',
    creditsUsed: 1320,
    creditsLimit: 1500,
    sharedCreditsLabel: null,
    tokensThisWeek: 12690000,
    percentOfAll: 6.4,
    status: 'near_limit',
  },
  {
    id: '6',
    initials: 'JC',
    name: 'James Carter',
    email: 'james.carter@selisegroup.com',
    isYou: true,
    plan: 'Starter',
    creditsUsed: 640,
    creditsLimit: 1500,
    sharedCreditsLabel: null,
    tokensThisWeek: 8240318,
    percentOfAll: 4.2,
    status: null,
  },
  {
    id: '7',
    initials: 'MK',
    name: 'Mia Keller',
    email: 'mia.keller@selisegroup.com',
    plan: null,
    creditsUsed: null,
    creditsLimit: null,
    sharedCreditsLabel: '155 shared',
    tokensThisWeek: 7905000,
    percentOfAll: 4.0,
    status: 'shared_credits_only',
  },
  {
    id: '8',
    initials: 'NK',
    name: 'Nadia Karim',
    email: 'nadia.karim@selisegroup.com',
    plan: 'Starter',
    creditsUsed: 410,
    creditsLimit: 1500,
    sharedCreditsLabel: null,
    tokensThisWeek: 5330000,
    percentOfAll: 2.7,
    status: null,
  },
  {
    id: '9',
    initials: 'RC',
    name: 'Rafi Chowdhury',
    email: 'rafi.chowdhury@selisegroup.com',
    plan: 'Starter',
    creditsUsed: 240,
    creditsLimit: 1500,
    sharedCreditsLabel: null,
    tokensThisWeek: 3210000,
    percentOfAll: 1.6,
    status: null,
  },
  {
    id: '10',
    initials: 'LM',
    name: 'Lukas Meier',
    email: 'lukas.meier@selisegroup.com',
    plan: 'Business Standard',
    creditsUsed: 120,
    creditsLimit: 4000,
    sharedCreditsLabel: null,
    tokensThisWeek: 1174101,
    percentOfAll: 0.6,
    status: 'plan_underused',
  },
  {
    id: '11',
    initials: 'AC',
    name: 'Alif Chowdhury',
    email: 'alif.chowdhury@selisegroup.com',
    plan: 'Starter',
    creditsUsed: 0,
    creditsLimit: 1500,
    sharedCreditsLabel: null,
    tokensThisWeek: 0,
    percentOfAll: 0,
    status: 'seat_unused',
  },
  {
    id: '12',
    initials: 'TH',
    name: 'Tom Hughes',
    email: 'tom.hughes@selisegroup.com',
    plan: 'Starter',
    creditsUsed: 0,
    creditsLimit: 1500,
    sharedCreditsLabel: null,
    tokensThisWeek: 0,
    percentOfAll: 0,
    status: null,
  },
  {
    id: '13',
    initials: 'PL',
    name: 'Priya Lang',
    email: 'priya.lang@selisegroup.com',
    plan: null,
    creditsUsed: null,
    creditsLimit: null,
    sharedCreditsLabel: null,
    tokensThisWeek: 0,
    percentOfAll: 0,
    status: null,
  },
  {
    id: '14',
    initials: 'OB',
    name: 'Omar Bakri',
    email: 'omar.bakri@selisegroup.com',
    plan: 'Starter',
    creditsUsed: 0,
    creditsLimit: 1500,
    sharedCreditsLabel: null,
    tokensThisWeek: 0,
    percentOfAll: 0,
    status: null,
  },
  {
    id: '15',
    initials: 'YN',
    name: 'Yuna Park',
    email: 'yuna.park@selisegroup.com',
    plan: 'Starter',
    creditsUsed: 0,
    creditsLimit: 1500,
    sharedCreditsLabel: null,
    tokensThisWeek: 0,
    percentOfAll: 0,
    status: null,
  },
  {
    id: '16',
    initials: 'FG',
    name: 'Felix Grant',
    email: 'felix.grant@selisegroup.com',
    plan: null,
    creditsUsed: null,
    creditsLimit: null,
    sharedCreditsLabel: null,
    tokensThisWeek: 0,
    percentOfAll: 0,
    status: null,
  },
  {
    id: '17',
    initials: 'HL',
    name: 'Hana Lee',
    email: 'hana.lee@selisegroup.com',
    plan: 'Starter',
    creditsUsed: 0,
    creditsLimit: 1500,
    sharedCreditsLabel: null,
    tokensThisWeek: 0,
    percentOfAll: 0,
    status: null,
  },
];

export function isAtOrNearLimit(person: TeamsPerson) {
  return person.status === 'near_limit' || person.status === 'at_daily_limit';
}

export function isNotUsing(person: TeamsPerson) {
  return person.tokensThisWeek === 0;
}

export function sortTeamsPeopleByCredits(people: TeamsPerson[]) {
  return [...people].sort((a, b) => (b.creditsUsed ?? -1) - (a.creditsUsed ?? -1));
}

export function filterTeamsPeople(people: TeamsPerson[], filter: TeamsUsageFilter, query: string) {
  const normalized = query.trim().toLowerCase();
  return people.filter((person) => {
    if (filter === 'at_or_near_limit' && !isAtOrNearLimit(person)) return false;
    if (filter === 'not_using' && !isNotUsing(person)) return false;
    if (!normalized) return true;
    return (
      person.name.toLowerCase().includes(normalized) ||
      person.email.toLowerCase().includes(normalized)
    );
  });
}

export function countTeamsFilter(people: TeamsPerson[], filter: TeamsUsageFilter) {
  return filterTeamsPeople(people, filter, '').length;
}

export type TeamsMemberRequest = 'upgrade' | 'credit' | null;
export type TeamsMemberStatus = 'active' | 'inactive';

export type TeamsMember = {
  id: string;
  initials: string;
  name: string;
  email: string;
  isYou?: boolean;
  plan: string | null;
  creditAccess: boolean;
  creditsUsed: number | null;
  lastLogin: string | null;
  /** IAM createdDate; shown when Columns → Joined on is on. */
  joinedOn?: string | null;
  status: TeamsMemberStatus;
  request: TeamsMemberRequest;
};

/** Figma Teams People table (10631:5798) — 21 members, first page shows 10. */
export const TEAMS_MEMBERS: TeamsMember[] = [
  {
    id: 'm1',
    initials: 'AC',
    name: 'Alif Chowdhury',
    email: 'alif.chowdhury@selisegroup.com',
    plan: 'Starter',
    creditAccess: false,
    creditsUsed: null,
    lastLogin: '18.09.2026',
    status: 'active',
    request: null,
  },
  {
    id: 'm2',
    initials: 'AE',
    name: 'Alvi E',
    email: 'alvi.ehsan+200@selisegroup.com',
    plan: null,
    creditAccess: false,
    creditsUsed: null,
    lastLogin: '27.10.2026',
    status: 'active',
    request: 'upgrade',
  },
  {
    id: 'm3',
    initials: 'AE',
    name: 'Alvi Ehsan',
    email: 'alvi.ehsan@selisegroup.com',
    plan: 'Business Standard',
    creditAccess: false,
    creditsUsed: null,
    lastLogin: '27.10.2026',
    status: 'active',
    request: null,
  },
  {
    id: 'm4',
    initials: 'AK',
    name: 'Andreas Kimpouropoulos',
    email: 'andreas.kimpouropoulos@selisegroup.com',
    plan: 'Business Standard',
    creditAccess: true,
    creditsUsed: 180,
    lastLogin: '21.10.2026',
    status: 'active',
    request: null,
  },
  {
    id: 'm5',
    initials: 'AD',
    name: 'Anika Das',
    email: 'anika.das@selisegroup.com',
    plan: null,
    creditAccess: false,
    creditsUsed: null,
    lastLogin: null,
    status: 'inactive',
    request: null,
  },
  {
    id: 'm6',
    initials: 'AS',
    name: 'Arijit Saha',
    email: 'arijit.saha@selisegroup.com',
    plan: null,
    creditAccess: false,
    creditsUsed: null,
    lastLogin: null,
    status: 'inactive',
    request: null,
  },
  {
    id: 'm7',
    initials: 'DC',
    name: 'Deepsika Chhetri',
    email: 'deepsika.chhetri@selisegroup.com',
    plan: 'Starter',
    creditAccess: false,
    creditsUsed: null,
    lastLogin: '30.10.2026',
    status: 'active',
    request: 'upgrade',
  },
  {
    id: 'm8',
    initials: 'ER',
    name: 'Elena Rossi',
    email: 'elena.rossi@selisegroup.com',
    plan: 'Business Standard',
    creditAccess: false,
    creditsUsed: null,
    lastLogin: '30.10.2026',
    status: 'active',
    request: null,
  },
  {
    id: 'm9',
    initials: 'JC',
    name: 'James Carter',
    email: 'james.carter@selisegroup.com',
    isYou: true,
    plan: 'Starter',
    creditAccess: true,
    creditsUsed: 40,
    lastLogin: '01.11.2026',
    status: 'active',
    request: null,
  },
  {
    id: 'm10',
    initials: 'JW',
    name: 'Jonas Weber',
    email: 'jonas.weber@selisegroup.com',
    plan: 'Starter',
    creditAccess: false,
    creditsUsed: null,
    lastLogin: '29.10.2026',
    status: 'active',
    request: 'credit',
  },
  {
    id: 'm11',
    initials: 'MK',
    name: 'Mia Keller',
    email: 'mia.keller@selisegroup.com',
    plan: 'Starter',
    creditAccess: false,
    creditsUsed: null,
    lastLogin: '15.10.2026',
    status: 'active',
    request: null,
  },
  {
    id: 'm12',
    initials: 'NK',
    name: 'Nadia Karim',
    email: 'nadia.karim@selisegroup.com',
    plan: 'Starter',
    creditAccess: true,
    creditsUsed: 12,
    lastLogin: '12.10.2026',
    status: 'active',
    request: null,
  },
  {
    id: 'm13',
    initials: 'RC',
    name: 'Rafi Chowdhury',
    email: 'rafi.chowdhury@selisegroup.com',
    plan: null,
    creditAccess: false,
    creditsUsed: null,
    lastLogin: null,
    status: 'inactive',
    request: null,
  },
  {
    id: 'm14',
    initials: 'LM',
    name: 'Lukas Meier',
    email: 'lukas.meier@selisegroup.com',
    plan: 'Business Standard',
    creditAccess: false,
    creditsUsed: null,
    lastLogin: '08.10.2026',
    status: 'active',
    request: null,
  },
  {
    id: 'm15',
    initials: 'SB',
    name: 'Sara Brandt',
    email: 'sara.brandt@selisegroup.com',
    plan: 'Starter',
    creditAccess: false,
    creditsUsed: null,
    lastLogin: '05.10.2026',
    status: 'active',
    request: null,
  },
  {
    id: 'm16',
    initials: 'TH',
    name: 'Tom Hughes',
    email: 'tom.hughes@selisegroup.com',
    plan: null,
    creditAccess: false,
    creditsUsed: null,
    lastLogin: null,
    status: 'inactive',
    request: null,
  },
  {
    id: 'm17',
    initials: 'PL',
    name: 'Priya Lang',
    email: 'priya.lang@selisegroup.com',
    plan: 'Starter',
    creditAccess: false,
    creditsUsed: null,
    lastLogin: '02.10.2026',
    status: 'active',
    request: null,
  },
  {
    id: 'm18',
    initials: 'OB',
    name: 'Omar Bakri',
    email: 'omar.bakri@selisegroup.com',
    plan: 'Starter',
    creditAccess: true,
    creditsUsed: 5,
    lastLogin: '28.09.2026',
    status: 'active',
    request: null,
  },
  {
    id: 'm19',
    initials: 'YN',
    name: 'Yuna Park',
    email: 'yuna.park@selisegroup.com',
    plan: null,
    creditAccess: false,
    creditsUsed: null,
    lastLogin: null,
    status: 'inactive',
    request: null,
  },
  {
    id: 'm20',
    initials: 'FG',
    name: 'Felix Grant',
    email: 'felix.grant@selisegroup.com',
    plan: 'Starter',
    creditAccess: false,
    creditsUsed: null,
    lastLogin: '20.09.2026',
    status: 'active',
    request: null,
  },
  {
    id: 'm21',
    initials: 'HL',
    name: 'Hana Lee',
    email: 'hana.lee@selisegroup.com',
    plan: 'Starter',
    creditAccess: false,
    creditsUsed: null,
    lastLogin: '10.09.2026',
    status: 'active',
    request: null,
  },
];

export function filterTeamsMembers(members: TeamsMember[], query: string) {
  const normalized = query.trim().toLowerCase();
  if (!normalized) return members;
  return members.filter(
    (member) =>
      member.name.toLowerCase().includes(normalized) ||
      member.email.toLowerCase().includes(normalized)
  );
}

/** Figma plan picker (10631:6553). */
export type TeamsPlanOption = {
  id: string;
  name: string;
  detail: string;
  nameKey: string;
  detailKey: string;
};

export const TEAMS_PLAN_OPTIONS: TeamsPlanOption[] = [
  {
    id: 'starter',
    name: 'Starter',
    detail: 'CHF 19.90 / month · 1 seat free',
    nameKey: 'TEAMS_PLAN_STARTER',
    detailKey: 'TEAMS_PLAN_STARTER_DETAIL',
  },
  {
    id: 'business-standard',
    name: 'Business Standard',
    detail: 'CHF 99 / month · No seat free, buy one',
    nameKey: 'TEAMS_PLAN_BUSINESS_STANDARD',
    detailKey: 'TEAMS_PLAN_BUSINESS_STANDARD_DETAIL',
  },
  {
    id: 'business-pro',
    name: 'Business Pro',
    detail: 'CHF 199 / month · No seat free, buy one',
    nameKey: 'TEAMS_PLAN_BUSINESS_PRO',
    detailKey: 'TEAMS_PLAN_BUSINESS_PRO_DETAIL',
  },
];

/** Figma Buy seats dialog (10827:7441 — A3.3 People / Buy a seat for this person). */
export type TeamsBuySeatPlan = {
  id: string;
  name: string;
  priceChf: number;
  ownedSeats: number;
  freeSeats: number;
};

export const TEAMS_BUY_SEAT_PLANS: TeamsBuySeatPlan[] = [
  { id: 'starter', name: 'Starter', priceChf: 19.9, ownedSeats: 7, freeSeats: 1 },
  {
    id: 'business-standard',
    name: 'Business Standard',
    priceChf: 99,
    ownedSeats: 4,
    freeSeats: 0,
  },
  { id: 'business-pro', name: 'Business Pro', priceChf: 199, ownedSeats: 0, freeSeats: 0 },
];

export const TEAMS_PAYMENT_METHOD_LABEL = 'Visa ending 4242';
export const TEAMS_PAYMENT_METHOD_EXPIRY = 'Expires 08 / 2028';
/** Mock next billing start shown in the Buy seats summary (Figma A3.3). */
export const TEAMS_BUY_SEAT_BILLING_START = 'Dec 1, 2026';

/** Figma A3.9 Add user — roles. */
export type TeamsInviteRole = {
  id: 'member' | 'admin';
  name: string;
  helper: string;
};

export const TEAMS_INVITE_ROLES: TeamsInviteRole[] = [
  {
    id: 'member',
    name: 'Member',
    helper: 'Can use Klax with the plan you give them.',
  },
  {
    id: 'admin',
    name: 'Admin',
    helper: 'Can manage people, plans and billing for this workspace.',
  },
];

/** Figma A3.18 Review and pay — saved billing defaults. */
export const TEAMS_BILLING_DEFAULTS = {
  legalName: 'SELISE Digital Platforms AG',
  contact: 'James Carter',
  email: 'finance@selise.ch',
  address: 'Hardturmstrasse 161',
  postalCode: '8005',
  city: 'Zürich',
  countryCode: 'CH',
  taxId: 'CHE-123.456.789 MWST',
};

export function formatTeamsPlanPrice(priceChf: number) {
  if (Number.isInteger(priceChf)) return `CHF ${priceChf}`;
  return `CHF ${priceChf.toFixed(2)}`;
}

export function formatTeamsInvitePlanLabel(plan: TeamsBuySeatPlan) {
  return `${plan.name} · ${plan.freeSeats}/${plan.ownedSeats} seats free · ${formatTeamsPlanPrice(plan.priceChf)} / month`;
}


export type TeamsRequestFilter = 'all' | 'plan_upgrades' | 'credits';

export type TeamsPendingRequest = {
  id: string;
  initials: string;
  name: string;
  email: string;
  kind: 'plan_upgrade' | 'credits';
  fromPlan: string | null;
  toPlan: string | null;
  title: string | null;
  context: string;
  note: string | null;
  creditAccess: boolean;
};

export type TeamsHandledRequest = {
  id: string;
  name: string;
  description: string;
  outcomeLabel: string;
  date: string;
};

/** Figma Teams Requests pending rows (10631:19766). */
export const TEAMS_PENDING_REQUESTS: TeamsPendingRequest[] = [
  {
    id: 'r1',
    initials: 'DC',
    name: 'Deepsika Chhetri',
    email: 'deepsika.chhetri@selisegroup.com',
    kind: 'plan_upgrade',
    fromPlan: 'Starter',
    toPlan: 'Business Standard',
    title: null,
    context: 'Reached daily limit · 2 hr ago',
    note: '“I run out before lunch most days.”',
    creditAccess: false,
  },
  {
    id: 'r2',
    initials: 'AE',
    name: 'Alvi E',
    email: 'alvi.ehsan+200@selisegroup.com',
    kind: 'plan_upgrade',
    fromPlan: null,
    toPlan: 'Starter',
    title: null,
    context: 'Has no plan yet · Yesterday',
    note: null,
    creditAccess: false,
  },
  {
    id: 'r3',
    initials: 'JW',
    name: 'Jonas Weber',
    email: 'jonas.weber@selisegroup.com',
    kind: 'credits',
    fromPlan: null,
    toPlan: null,
    title: 'Access to shared credits',
    context: '88% of monthly limit · Yesterday',
    note: '“Finishing the Q4 outreach list.”',
    creditAccess: false,
  },
];

/** Figma Teams Requests handled rows (10631:19849). */
export const TEAMS_HANDLED_REQUESTS: TeamsHandledRequest[] = [
  {
    id: 'h1',
    name: 'James Carter',
    description: 'Access to shared credits',
    outcomeLabel: 'Given credit access',
    date: 'Oct 12',
  },
  {
    id: 'h2',
    name: 'Lukas Meier',
    description: 'Access to shared credits',
    outcomeLabel: 'Given credit access',
    date: 'Oct 24',
  },
];

export function filterTeamsPendingRequests(
  requests: TeamsPendingRequest[],
  filter: TeamsRequestFilter,
  query: string
) {
  const normalized = query.trim().toLowerCase();
  return requests.filter((request) => {
    if (filter === 'plan_upgrades' && request.kind !== 'plan_upgrade') return false;
    if (filter === 'credits' && request.kind !== 'credits') return false;
    if (!normalized) return true;
    return (
      request.name.toLowerCase().includes(normalized) ||
      request.email.toLowerCase().includes(normalized)
    );
  });
}

export function countTeamsRequestFilter(
  requests: TeamsPendingRequest[],
  filter: TeamsRequestFilter
) {
  return filterTeamsPendingRequests(requests, filter, '').length;
}

export function filterTeamsHandledRequests(requests: TeamsHandledRequest[], query: string) {
  const normalized = query.trim().toLowerCase();
  if (!normalized) return requests;
  return requests.filter(
    (request) =>
      request.name.toLowerCase().includes(normalized) ||
      request.description.toLowerCase().includes(normalized)
  );
}
